/* eslint-disable */
import { useMemo } from "react";
import { useDictionary, useOLAPTransformer, OLAPTransformerResult, OLAPTransformerOptions } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import { SLIDE_NUMBER } from "../constants";

const ROW_AXIS = "attributes.default";
const COLUMN_AXIS = "calendar.default";

export function useTableData(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, columnsDict] = useDictionary(dictionaryService, "calendar-origin");
  const [itemsRows, rowsDict] = useDictionary(dictionaryService, "slides-attributes");

  const options = useMemo<OLAPTransformerOptions | null>(() => {
    if ([olapResult, columnsDict, rowsDict, itemsRows].some(x => !Boolean(x))) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsDictionaries: new Map([
        [COLUMN_AXIS, columnsDict],
        [ROW_AXIS, rowsDict],
      ]) as ReadonlyMap<string, Dictionary>
    } as OLAPTransformerOptions
  }, [olapResult, columnsDict, rowsDict, itemsRows]);

  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${COLUMN_AXIS}.name`, `${COLUMN_AXIS}.id`],
      rows: [`${ROW_AXIS}.name`, `${ROW_AXIS}.id`],
      cellData: {
        inCell: ["Measures.value"],
        attributes: [`${COLUMN_AXIS}.name`, `${ROW_AXIS}.name`, `${COLUMN_AXIS}.id`, `${ROW_AXIS}.id`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
